import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { News } from 'src/app/models/obs/news';
import { ContentNews } from 'src/app/models/obs/contentnews';
import { Message } from 'src/app/models/message';
import { NewsService } from 'src/app/services/obs/news.service';
import { ContentnewsService } from 'src/app/services/obs/contentnews.service';
import { BridgeService } from 'src/app/services/util/bridge.service';
import { urlEndPoint } from 'src/app/common';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  events: any[] = [
    {
      name: 'Megatendencias',
      summary: 'Grandes fuerzas de cambio de escala global, de implicancias transversales y con el potencial de afectar el desarrollo de los países en el largo plazo.',
      img: 'assets/img/home/m1.webp',
      route: '../megatendencia',
      class: 'm-bk'
    },
    {
      name: 'Tendencias',
      summary: 'Fenómenos que muestra un comportamiento determinado, el cual se puede asumir que continuará en el futuro.',
      img: 'assets/img/home/t1.webp',
      route: '../tendencia',
      class: 't-bk'
    },
    {
      name: 'Riesgos',
      summary: 'Condiciones o eventos potenciales que de ocurrir tendrían un impacto negativo sobre el bienestar de la población peruana y el desarrollo nacional.',
      img: 'assets/img/home/r1.webp',
      route: '../riesgo',
      class: 'r-bk'
    },
    {
      name: 'Oportunidades',
      summary: 'Condiciones o eventos que favorecen el proceso de construcción de futuro deseable para el bienestar de la población o el desarrollo nacional, siempre y cuando se tomen las decisiones adecuadas y oportunas para su aprovechamiento.',
      img: 'assets/img/home/o1.webp',
      route: '../oportunidad',
      class: 'o-bk'
    },
    {
      name: 'Escenarios',
      summary: 'Futuros alternativos que comprenden un conjunto de condiciones posibles para el país. Su exploración y análisis sistémico buscan reducir la incertidumbre y anticiparse estratégicamente.',
      img: 'assets/img/home/s1.webp',
      route: '../escenario',
      class: 'sc-bk'
    },
    {
      name: 'Eventos futuros',
      summary: 'Circunstancia o fenómeno que puede manifestarse en lo sucesivo de relevancia para el tomador de decisiones.',
      img: 'assets/img/s/e1.webp',
      route: '../evento',
      class: 's-bk'
    }
  ];

  n: News = null;
  e: News = null;
  c_n: ContentNews[] = [];
  c_e: ContentNews[] = [];
  msg: Message;
  selectedSectorId: string | null = null;
  URL:string = urlEndPoint;

  constructor(
    private sNews: NewsService,
    private sCNews: ContentnewsService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private bridgeService: BridgeService
  ) { }

  ngOnInit() {
    this.catchIdSectorialTrend();
    this.getLastNews();
    this.getLastEv();
    this.subscritorPage();
  }

  isIframeReady: boolean = false;

  catchIdSectorialTrend() {
    this.bridgeService.selectedSectorId$.subscribe(sectorId => {
      this.selectedSectorId = sectorId;
    });
  }

  onIframeLoad() {
    console.log('Iframe cargado');
    this.isIframeReady = true;
    this.cd.detectChanges();
  }

  subscritorPage() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      // Generamos la excepcion a la ruta /tendencia-sectorial/:id para lo cual importamos 
      //el id de la vista en cuestion
      if (this.router.url !== '/tendencia-sectorial/' + this.selectedSectorId) {
        window.scrollTo(0, 0);
      }
    });
  }

  getLastNews() {
    this.sNews.getLastNews().subscribe(
      {
        next: res => {
          this.n = res['data'];
          this.getContentNews(this.n[0].id);
        },
        error: err => { this.msg = err; }
      }
    );
  }

  getLastEv() {
    this.sNews.getLastEv().subscribe(
      {
        next: res => {
          this.e = res['data'];
          this.getContentEv(this.e[0].id);
        },
        error: err => { this.msg = err; }
      }
    );
  }

  getContentNews(id: string) {
    this.sCNews.get4News(id).subscribe(
      {
        next: res => {
          this.c_n = res['data'];
        },
        error: err => { this.msg = err; }
      }
    );
  }

  getContentEv(id: string) {
    this.sCNews.get4News(id).subscribe(
      {
        next: res => {
          this.c_e = res['data'];
        },
        error: err => { this.msg = err; }
      }
    );
  }

}